var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// src/idle-start.ts
var TRACKER_START_FALLBACK_MS = 5e3;
var TRACKER_IDLE_CALLBACK_TIMEOUT_MS = 1e3;
var VISITOR_INTERACTION_EVENTS = [
  "pointerdown",
  "keydown",
  "touchstart",
  "scroll",
  "wheel"
];
function createBrowserIdleStartHost() {
  return {
    isDocumentLoaded: /* @__PURE__ */ __name(() => document.readyState === "comp\
lete", "isDocumentLoaded"),
    listen: /* @__PURE__ */ __name((eventName, listener) => {
      const options = { passive: true, capture: true };
      window.addEventListener(eventName, listener, options);
      return () => window.removeEventListener(eventName, listener, options);
    }, "listen"),
    startTimer: /* @__PURE__ */ __name((callback, delayMs) => {
      const handle = window.setTimeout(callback, delayMs);
      return () => window.clearTimeout(handle);
    }, "startTimer"),
    requestIdle: typeof window.requestIdleCallback === "function" ? (callback, timeoutMs) => {
      const handle = window.requestIdleCallback(callback, { timeout: timeoutMs });
      return () => window.cancelIdleCallback(handle);
    } : void 0
  };
}
__name(createBrowserIdleStartHost, "createBrowserIdleStartHost");
function scheduleAfterIdleOrInteraction(task, options = {}) {
  const { fallbackMs = TRACKER_START_FALLBACK_MS, host = createBrowserIdleStartHost() } = options;
  let hasSettled = false;
  const releaseResources = [];
  const releaseAll = /* @__PURE__ */ __name(() => {
    for (const release of releaseResources.splice(0)) {
      release();
    }
  }, "releaseAll");
  const runTaskOnce = /* @__PURE__ */ __name(() => {
    if (hasSettled) {
      return;
    }
    hasSettled = true;
    releaseAll();
    task();
  }, "runTaskOnce");
  const startFallbackTimer = /* @__PURE__ */ __name(() => {
    releaseResources.push(
      host.startTimer(() => {
        if (host.requestIdle === void 0) {
          runTaskOnce();
          return;
        }
        releaseResources.push(host.requestIdle(runTaskOnce, TRACKER_IDLE_CALLBACK_TIMEOUT_MS));
      }, fallbackMs)
    );
  }, "startFallbackTimer");
  for (const eventName of VISITOR_INTERACTION_EVENTS) {
    releaseResources.push(host.listen(eventName, runTaskOnce));
  }
  if (host.isDocumentLoaded()) {
    startFallbackTimer();
  } else {
    releaseResources.push(host.listen("load", startFallbackTimer));
  }
  return () => {
    hasSettled = true;
    releaseAll();
  };
}
__name(scheduleAfterIdleOrInteraction, "scheduleAfterIdleOrInteraction");
export {
  TRACKER_IDLE_CALLBACK_TIMEOUT_MS,
  TRACKER_START_FALLBACK_MS,
  VISITOR_INTERACTION_EVENTS,
  createBrowserIdleStartHost,
  scheduleAfterIdleOrInteraction
};
